import { createReducer } from '@reduxjs/toolkit';
import { linkedAdjustmentsForDocumentUpdated } from '../actions/linkedAdjustments';

const linkedAdjustmentsByDocument = createReducer(
  {},
  {
    [linkedAdjustmentsForDocumentUpdated]: (state, action) => {
      const { documentCode, linkedAdjustments } = action.payload;
      state[documentCode] = linkedAdjustments;
    },
  }
);

export default linkedAdjustmentsByDocument;
